import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

const context = require.context('.', true, /\.section\.js$/);
const sectionFiles = context.keys()
  .map(key => ({ section: key.replace(/.*\/([^/]*?).section.js/, '$1'), key }));
export const components = {};


sectionFiles.forEach(({ section, key }) => {
  components[section] = (context(key) || {}).default;
});

function SectionsLoader({ page }) {
  const sections = (get(page, 'meta.fields') || [])
    .filter(field => get(field, 'pageSectionName'))
    .reduce((list, field) => {
      const Component = components[get(field, 'pageSectionName')];
      if (field.pageSectionPublished && Component) {
        list.push({ Component, field });
      }
      return list;
    }, []);

  return (
    <div>
      {
        sections.map(({ Component, field: { key } }) => (
          <div key={key}>
            <Component currentPage={page} content={get(page, key)} dataKey={key} />
          </div>
        ))
      }
    </div>
  );
}

SectionsLoader.propTypes = {
  page: PropTypes.shape({
    meta: PropTypes.object.isRequired,
  }).isRequired,
};

export default SectionsLoader;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/index.js